import styled from "styled-components";

export const Group = styled.div`
  flex-direction: column;
  display: flex;
  margin-top: 12px;
  margin-bottom: 24px;
  gap: 10px;
`;

export const Item = styled.div`
  flex-direction: column;
  display: flex;
  .mark-label {
    flex-direction: row;
    display: flex;
  }
  .gender-optional {
    margin-bottom: 20px;
  }
`;

export const Label = styled.label`
  color: #000;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-right: 22px;
`

export const Checkmark = styled.div`
  height: 16px;
  width: 16px;
  background-color: #eee;
  border-radius: 50%;
  position: relative;
  margin-right: 10px;
  border: 1px solid #707070;
  justify-content: center;
  align-items: center;
  display: flex;
`

export const CheckmarkInternalCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  box-shadow: 0px 0px 4px #00000022;
`
